import React, {useState} from 'react';
import s from '../MyOrdersForManager.module.css';
import TableButtonsActions, {
	ActionConfig,
} from '../../../Components/TableButtonsActions/TableButtonsActions';
import {useTranslation} from 'react-i18next';
import act04 from '../../../assets/img/icons/actions/actioms04.svg';
import infoButton from '../../../assets/img/icons/actions/info.svg';
import {OrderInfo} from '../../../types/TypesUserOrders';
import {useLazyOrderInfoQuery} from '../../../redux/userOrdersApi';
import {generateOrderPDF} from '../../../utils/pdfGenerator';
import {handleApiCall} from '../../../assets/utils/utils';
import PopupManagerInfo from '../MyOrdersPopups/Info/PopupManagerInfo';

type Props = {
	order: OrderInfo;
};

const StoreOrdersActions: React.FC<Props> = ({order}) => {
	const {t} = useTranslation();

	const [openInfoPopup, setOpenInfoPopup] = useState<boolean>(false);
	const [trigger, {data, isLoading}] = useLazyOrderInfoQuery();

	// === HANDLERS ===
	const handlers = {
		print: async (id: number) => {
			try {
				console.log('Store order data before PDF generation:', order);
				await generateOrderPDF(order);
			} catch (error) {
				console.error('Ошибка генерации PDF:', error);
			}
		},
		info: async (id: number) => {
			await handleApiCall({
				apiCall: () => trigger(id),
				onSuccess: () => setOpenInfoPopup(true),
			});
		},
	};

	const actions: ActionConfig[] = [
		{
			type: 'print',
			icon: act04,
			label: t('Друк'),
			handler: handlers.print,
		},
		{
			type: 'info',
			icon: infoButton,
			label: t('Інфо'),
			handler: handlers.info,
		},
	];

	const handleClosePopup = () => {
		setOpenInfoPopup(false);
	};

	return (
		<div className={s.actions}>
			{openInfoPopup && !isLoading && data && (
				<PopupManagerInfo orderInfo={data} close={handleClosePopup} />
			)}
			<div>
				<TableButtonsActions
					actions={actions}
					orderId={order.id}
					orderStatus={order.status}
				/>
			</div>
		</div>
	);
};

export default StoreOrdersActions;
